import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

interface Props {
  className?: string;
}

const PersonEdit = (props: Props) => {
  const { className } = props;

  return (
    <SvgIcon className={className} viewBox="0 0 22 16">
      <g>
        <path
          d="M8+0C5.79+0+4+1.79+4+4C4+6.205+5.79+8+8+8C10.21+8+12+6.205+12+4C12+1.79+10.21+0+8+0ZM19.8125+6.15625L18.8125+7.1875L20.875+9.25L21.9062+8.25C22.1229+8.03333+22.1229+7.68542+21.9062+7.46875L20.5938+6.15625C20.3771+5.93958+20.0292+5.93958+19.8125+6.15625ZM18.2188+7.78125L12.0625+13.9062L12.0625+16L14.1562+16L20.2812+9.84375L18.2188+7.78125ZM8+10C5.335+10+3.17891e-07+11.335+0+14L0+16L10.9062+16L10.9062+13.0312L13.0312+11C11.359+10.3258+9.33978+10+8+10Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
};

export default PersonEdit;
